export default class Accordion {
    constructor(container) {
        this.container = container;
        this.btn = this.container?.querySelector(".js-btn-accordion");
        this.body = this.container?.querySelector(".js-accordion-body");
    }

    init() {
        $(this.container).hasClass("is-open")
            && $(this.body).slideDown();

        this.btn?.addEventListener("click", (e) => {
            if ($(this.body).is(":hidden")) {
                !$(this.container).hasClass("is-open")
                    && $(this.container).addClass("is-open");
                $(this.body).slideDown();

            } else {
                $(this.container).removeClass("is-open");
                $(this.body).slideUp();
            }
        });
    }

}